module.exports = __webpack_public_path__ + "media/images/fm_4-578b2727fa2c1f738bc02b68dd89ce71.png";